<p>clinical-examination works!</p>